export default {
    sleep(ms) {
        // TODO: move to global scope
        return new Promise(resolve => setTimeout(resolve, ms));
    },
}
